(function($) {

	$.fn.msxidropdownmenu = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.msxidropdownmenu.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            $(".submenu-item", $this).click(function(){
                var $link = $(this);
                $(".submenu-item", $this).not($link).next("ul.submenu").slideUp('fast');
                $link.next("ul").slideToggle('fast');
                return false;
            });

            $(".submenu", $this).hover(
                function(){},
                function(){
                    var $submenu = $(this);
                    $submenu.slideUp('fast');
            });

            $(".submenu-item", $this).hover(function(){
                var $subMenuItem = $(this);
                var $subMenu = $subMenuItem.siblings('ul.submenu');
                    $('ul.submenu:visible', $this).not($subMenu).each(function(){
                        $(this).slideUp('fast');
                        $subMenu.slideDown('fast');
                    });
                },
                function(){});

            $("html").click(function(eventObject){
                if($(eventObject.target).parents().filter($this).size()==0)
                {
                    $("ul.submenu", $this).slideUp('fast');
                }
            });

            // add this class at end so that CSS link styles do not apply until menu is ready
            $this.find('> ul').addClass('menu');
        });

	};
	//
	// plugin defaults
	//
	$.fn.msxidropdownmenu.defaults = {
	};

})(jQuery);